var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190,
    height: 166,
    viewBox: "0 0 190 166",
    id: "excel",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "j",
    width: 142,
    height: 166,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "m",
    width: 71,
    height: 42,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "q",
    width: 71,
    height: 42,
    x: 71,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "u",
    width: 71,
    height: 42,
    y: -1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "y",
    width: 71,
    height: 42,
    x: 71,
    y: -1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "C",
    width: 71,
    height: 42,
    y: 83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "G",
    width: 71,
    height: 42,
    x: 71,
    y: 83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "K",
    width: 71,
    height: 42,
    y: 125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "O",
    width: 71,
    height: 42,
    x: 71,
    y: 125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "R",
    width: 142,
    height: 166,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "U",
    width: 96,
    height: 96,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "aa",
    width: 96,
    height: 98,
    y: -1,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    width: "143.7%",
    height: "173.8%",
    x: "-21.8%",
    y: "-36.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner3",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner3",
    result: "shadowMatrixInner3",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner3"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    width: "101.4%",
    height: "102.4%",
    x: "-.7%",
    y: "-1.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.15 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "A",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0.709803922   0 0 0 0 0.37254902  0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "E",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "I",
    width: "101.4%",
    height: "102.4%",
    x: "-.7%",
    y: "-1.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "M",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner3",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner3",
    result: "shadowMatrixInner3",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner3"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "Q",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "S",
    width: "117%",
    height: "117%",
    x: "-8.5%",
    y: "-8.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Z",
    width: "103.1%",
    height: "103.1%",
    x: "-1.6%",
    y: "-1.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 0.0199267733   0 0 0 0 0.65973108   0 0 0 0 0.312408742  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0.466666667   0 0 0 0 0.250980392  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ab",
    width: "141.7%",
    height: "137.9%",
    x: "-20.8%",
    y: "-17%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "6.294%",
    x2: "103.402%",
    y1: "0%",
    y2: "103.5%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#007438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.34%",
    stopColor: "#008B44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: "107.466%",
    x2: "6.294%",
    y1: "107.831%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00D576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.026%",
    stopColor: "#00A054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "6.294%",
    x2: "107.466%",
    y1: "0%",
    y2: "107.831%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#007E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95.983%",
    stopColor: "#009A50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: "6.294%",
    x2: "107.466%",
    y1: "0%",
    y2: "107.831%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00AD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E18C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: "107.466%",
    x2: "9.303%",
    y1: "107.831%",
    y2: "3.207%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#003D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004F2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: "107.466%",
    x2: "9.303%",
    y1: "107.831%",
    y2: "3.207%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#008D46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: "107.466%",
    x2: "9.303%",
    y1: "107.831%",
    y2: "3.207%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00522E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#003B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: "107.466%",
    x2: "9.303%",
    y1: "107.831%",
    y2: "3.207%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#006D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: "113.177%",
    x2: "2.151%",
    y1: "104.673%",
    y2: "9.713%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: "29.468%",
    x2: "97.963%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "n",
    width: 512,
    height: 512,
    x: -512,
    y: -471,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "r",
    width: 512,
    height: 512,
    x: -441,
    y: -471,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "v",
    width: 512,
    height: 512,
    x: -512,
    y: -513,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "z",
    width: 512,
    height: 512,
    x: -441,
    y: -513,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "D",
    width: 512,
    height: 512,
    x: -512,
    y: -429,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "H",
    width: 512,
    height: 512,
    x: -441,
    y: -429,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "L",
    width: 512,
    height: 512,
    x: -512,
    y: -387,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "P",
    width: 512,
    height: 512,
    x: -441,
    y: -387,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "X",
    width: 512,
    height: 512,
    x: -512,
    y: -512,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "W",
    cx: "86.601%",
    cy: "84.21%",
    r: "62.398%",
    fx: "86.601%",
    fy: "84.21%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#018137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007E35",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "ac",
    points: "25 73.107 41.756 46.96 26.572 23 38.144 23 47.977 41.099 57.61 23 69.082 23 53.83 47.336 70.587 73.107 58.647 73.107 47.777 53.778 36.873 73.107"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    fill: "url(#n)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    fill: "#000",
    filter: "url(#o)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "url(#r)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "#000",
    filter: "url(#s)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "url(#v)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "#000",
    filter: "url(#w)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    fill: "url(#z)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    fill: "#000",
    filter: "url(#A)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    fill: "url(#D)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    fill: "#000",
    filter: "url(#E)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    fill: "url(#H)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    fill: "#000",
    filter: "url(#I)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K",
    fill: "url(#L)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K",
    fill: "#000",
    filter: "url(#M)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    fill: "url(#P)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    fill: "#000",
    filter: "url(#Q)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M-40,37 L40,37 C44.418278,37 48,40.581722 48,45 L48,125 C48,129.418278 34.418278,143 30,143 L-50,143 C-54.418278,143 -58,139.418278 -58,135 L-58,55 C-58,50.581722 -44.418278,37 -40,37 Z",
    filter: "url(#S)",
    mask: "url(#T)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Y",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U",
    fill: "url(#V)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U",
    fill: "url(#W)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U",
    fill: "url(#X)",
    fillOpacity: 0.013
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#Y)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa",
    filter: "url(#Z)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Y)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ac",
    fill: "#000",
    filter: "url(#ab)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ac",
    fill: "url(#ad)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.2f765266f62f7b2b9ba6f2d04e6a6333.svg";
export { ForwardRef as ReactComponent };